import { lenis, prefersReducedMotion } from '../lenis'

export function initModals() {
  document.querySelectorAll('[data-modal-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const modal = document.getElementById(trigger.dataset.modalOpen)

      if (!(modal instanceof HTMLDialogElement)) return

      event.preventDefault()
      modal.showModal()
      lenis.stop()
    })
  })

  document.querySelectorAll('[data-modal]').forEach((modal) => {
    const scrollArea = modal.querySelector('[data-modal-scroll]')
    let scrollTarget = 0
    let scrollFrame = 0

    const easeScroll = () => {
      const distance = scrollTarget - scrollArea.scrollTop

      if (Math.abs(distance) < 0.5) {
        scrollArea.scrollTop = scrollTarget
        scrollFrame = 0
        return
      }

      scrollArea.scrollTop += distance * 0.14
      scrollFrame = requestAnimationFrame(easeScroll)
    }

    scrollArea?.addEventListener(
      'wheel',
      (event) => {
        if (prefersReducedMotion.matches) return

        const deltaMultiplier = event.deltaMode === WheelEvent.DOM_DELTA_LINE ? 16 : 1
        const maxScroll = scrollArea.scrollHeight - scrollArea.clientHeight

        event.preventDefault()
        if (!scrollFrame) scrollTarget = scrollArea.scrollTop
        scrollTarget = Math.min(Math.max(scrollTarget + event.deltaY * deltaMultiplier * 0.8, 0), maxScroll)

        if (!scrollFrame) scrollFrame = requestAnimationFrame(easeScroll)
      },
      { passive: false }
    )

    modal.querySelector('[data-modal-close]')?.addEventListener('click', () => {
      modal.close()
    })

    // Desktop: backdrop click routes to the dialog element in Chrome
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close()
    })

    // iOS Safari: backdrop taps don't fire click on the dialog — use touchend on document
    document.addEventListener(
      'touchend',
      (event) => {
        if (!modal.open) return
        const touch = event.changedTouches[0]
        const rect = modal.getBoundingClientRect()
        if (
          touch.clientX < rect.left ||
          touch.clientX > rect.right ||
          touch.clientY < rect.top ||
          touch.clientY > rect.bottom
        ) {
          modal.close()
        }
      },
      { passive: true }
    )

    modal.addEventListener('close', () => {
      cancelAnimationFrame(scrollFrame)
      scrollFrame = 0
      lenis.start()
    })
  })
}
